"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function loadSDK(source, type) {
    if (type === void 0) { type = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var fileName, sdkFile, SDK;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileName = type.toUpperCase();
                    sdkFile = window[fileName];
                    if (sdkFile) {
                        return [2 /*return*/, sdkFile];
                    }
                    // window上未挂载SDK文件的情况下，检查是否传递参数
                    if (!source) {
                        return [2 /*return*/];
                    }
                    if (!isURL(source)) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadScript(source, fileName)];
                case 1:
                    SDK = _a.sent();
                    return [2 /*return*/, SDK];
                case 2: 
                // 其他情况，直接传递了SDK文件，则直接返回
                return [2 /*return*/, source];
            }
        });
    });
}
exports.loadSDK = loadSDK;
function isURL(URL) {
    var str = URL;
    var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
    var objExp = new RegExp(Expression);
    if (objExp.test(str) == true) {
        return true;
    }
    else {
        return false;
    }
}
function loadScript(url, fileName) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = url;
        // script.type = "text/javascript";
        script.crossOrigin = '';
        script.onload = function () {
            resolve(window[fileName]);
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZFNESy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9sb2FkU0RLLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBc0IsT0FBTyxDQUFDLE1BQVcsRUFBRSxJQUFTO0lBQVQscUJBQUEsRUFBQSxTQUFTOzs7Ozs7b0JBRzVDLFFBQVEsR0FBRyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7b0JBQzdCLE9BQU8sR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUE7b0JBQ2hDLElBQUksT0FBTyxFQUFFO3dCQUNYLHNCQUFPLE9BQU8sRUFBQTtxQkFDZjtvQkFFRCwrQkFBK0I7b0JBQy9CLElBQUksQ0FBQyxNQUFNLEVBQUU7d0JBQ1gsc0JBQU07cUJBQ1A7eUJBR0csS0FBSyxDQUFDLE1BQU0sQ0FBQyxFQUFiLHdCQUFhO29CQUNILHFCQUFNLFVBQVUsQ0FBQyxNQUFNLEVBQUUsUUFBUSxDQUFDLEVBQUE7O29CQUF4QyxHQUFHLEdBQUcsU0FBa0M7b0JBQzlDLHNCQUFPLEdBQUcsRUFBQTs7Z0JBR1osd0JBQXdCO2dCQUN4QixzQkFBTyxNQUFNLEVBQUE7Ozs7Q0FDZDtBQXRCRCwwQkFzQkM7QUFFRCxTQUFTLEtBQUssQ0FBQyxHQUFHO0lBQ2hCLElBQUksR0FBRyxHQUFHLEdBQUcsQ0FBQztJQUNkLElBQUksVUFBVSxHQUFHLG1EQUFtRCxDQUFDO0lBQ3JFLElBQUksTUFBTSxHQUFHLElBQUksTUFBTSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQ3BDLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxJQUFJLEVBQUU7UUFDNUIsT0FBTyxJQUFJLENBQUM7S0FDYjtTQUFNO1FBQ0wsT0FBTyxLQUFLLENBQUM7S0FDZDtBQUNILENBQUM7QUFFRCxTQUFTLFVBQVUsQ0FBQyxHQUFXLEVBQUUsUUFBZ0I7SUFDL0MsT0FBTyxJQUFJLE9BQU8sQ0FBQyxVQUFDLE9BQU8sRUFBRSxNQUFNO1FBQ2pDLElBQUksTUFBTSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLENBQUM7UUFDOUMsTUFBTSxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUM7UUFDakIsbUNBQW1DO1FBQ25DLE1BQU0sQ0FBQyxXQUFXLEdBQUcsRUFBRSxDQUFBO1FBQ3ZCLE1BQU0sQ0FBQyxNQUFNLEdBQUc7WUFDZCxPQUFPLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUE7UUFDM0IsQ0FBQyxDQUFBO1FBQ0QsTUFBTSxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUM7UUFDeEIsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDcEMsQ0FBQyxDQUFDLENBQUE7QUFDSixDQUFDIn0=